import { ThemeConfig } from '@kc/app-init-workflow';
import { ThemeOptions } from '@mui/material/styles';

export default function generateHeaderTheme(theme: ThemeConfig | undefined | null): ThemeOptions {
  if (!theme || !theme.palette) return {};

  return {
    palette: {
      primary: {
        main: theme.palette.secondary,
        contrastText: theme.palette.secondaryTextColor,
      },
      secondary: {
        main: theme.palette.tertiaryColor,
      },
      background: {
        default: theme.palette.darkColor,
        paper: theme.palette.brightColor,
      },
      text: {
        primary: theme.palette.brightColor,
      },
      warning: {
        main: theme.palette.warning,
      },
      success: {
        main: theme.palette.success,
      },
      error: {
        main: theme.palette.error,
      },
      divider: theme.palette.border,
      mode: 'dark',
    },
  };
}
